import { render, staticRenderFns } from "./matriz-peligro.vue?vue&type=template&id=a9994d5e&"
import script from "./matriz-peligro.vue?vue&type=script&lang=js&"
export * from "./matriz-peligro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports